import { render } from "./ViewProject.vue?vue&type=template&id=c8a9b6fc&scoped=true&ts=true"
import script from "./ViewProject.vue?vue&type=script&lang=ts"
export * from "./ViewProject.vue?vue&type=script&lang=ts"

import "./ViewProject.vue?vue&type=style&index=0&id=c8a9b6fc&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a9b6fc"]])

export default __exports__